import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]

  collect() {
    if (!this.hasFieldTarget) return

    try {
      this.fieldTarget.value = JSON.stringify(this.snapshot())
    } catch {
      this.fieldTarget.value = ""
    }
  }

  snapshot() {
    const base = { screen: `${window.innerWidth}x${window.innerHeight}`, online: navigator.onLine }
    const holders = document.querySelectorAll("[data-controller~='image']")
    if (holders.length === 0) return { ...base, page: "separate" }

    const images = Array.from(document.querySelectorAll("[data-controller~='image'] img"))
    const failed = images.filter((img) => !this.loaded(img))

    return {
      ...base,
      images: images.length,
      loaded: images.length - failed.length,
      failed: failed.map((img) => img.currentSrc || img.src).slice(0, 5)
    }
  }

  loaded(image) {
    return image.complete && image.naturalWidth > 0
  }
}
